import request from "./../utils/request";

export function getWhatsappSS(channelId) {
    return request.get(channelId ? `/whatsapp/ss?channelId=${channelId}` : `/whatsapp/ss`);
}

const WHATSAPP_API = {
    BROADCAST: {
        getGroupById: (id) => request.get(`/whatsapp/broadcast/groups/${id}`),
        deleteGroupById: (id) => request.delete(`/whatsapp/broadcast/groups/${id}`),
        updateGroup: (id, name, description, contacts, isBusiness, autoFixForTurkey) =>
            request.post(`/whatsapp/broadcast/groups/${id}`, {
                id,
                name,
                description,
                contacts,
                isBusiness,
                autoFixForTurkey,
            }),
        listGroups: (page, perPage, search) => request.get(`/whatsapp/broadcast/groups`, { params: { page, perPage, search } }),
        createGroup: (name, contacts, userId, isBusiness, autoFixForTurkey = true) =>
            request.put(`/whatsapp/broadcast/groups`, { name, contacts, userId, isBusiness }),

        saveAsWhatsappCustomerGroup: (siteId, filters, query, groupName) =>
            request.post(`/visitors/save-as-whatsapp-customer-group`, { siteId, filters, query, groupName }),
        getAllBroadcastMessages: () => request.get(`/whatsapp/broadcast/messages`),
        listActiveBroadcastMessage: () => request.get(`/whatsapp/broadcast/messages/active`),
        listActiveBroadcastMessagePaginated: (filters, cursor, sort) =>
            request.post(`/whatsapp/broadcast/messages/active-broadcasts-paginated`, { filters, cursor, sort }),
        listArchivedBroadcastMessage: () => request.get(`/whatsapp/broadcast/messages/archived`),
        listArchivedBroadcastMessagePaginated: (filters, cursor, sort) =>
            request.post(`/whatsapp/broadcast/messages/archived-broadcasts-paginated`, {
                filters,
                cursor,
                sort,
            }),
        listActiveBroadcastMessageLite: () => request.get(`/whatsapp/broadcast/messages/active/lite`),
        listArchivedBroadcastMessageLite: () => request.get(`/whatsapp/broadcast/messages/archived/lite`),
        getBroadcastMessageCountStats: () => request.get(`/whatsapp/broadcast/messages/stats`),
        getStatus: (ids) => request.post(`/whatsapp/broadcast/messages/status`, { ids }),
        getBroadcastMessageById: (id) => request.get(`/whatsapp/broadcast/messages/${id}`),
        getBroadcastDetails: (id) => request.get(`/whatsapp/broadcast/${id}/details`),
        updateBroadcastMessage: (id, updatingFields) =>
            request.post(`/whatsapp/broadcast/messages/${id}`, { updatingFields }),
        markArchiveBroadcastMessage: (id) =>
            request.post(`/whatsapp/broadcast/messages/${id}`, {
                updatingFields: {
                    archived: true,
                },
            }),
        getDownloadLinkBroadcastDetail: (filters) => request.post(`/whatsapp/broadcast/download`, filters),
        getBroadcastList: (limit = 50, search = "", startDate = null, endDate = null) => 
            request.get(`/whatsapp/broadcast/list`, { 
                params: { limit, search, startDate, endDate }
            }).then(response => response.data),
        createBroadcastMessage: (
            title,
            description,
            messages,
            all,
            groupId,
            excludePhoneNumbers,
            userId,
            scheduleAt,
            customPhoneNumbers,
            channel,
            selectedTemplate,
            templateParams,
            ticimaxPayload,
            sendTemplateViaMmlite
        ) =>
            request.put(`/whatsapp/broadcast/messages`, {
                title,
                description,
                messages,
                all,
                groupId,
                excludePhoneNumbers,
                userId,
                scheduleAt,
                customPhoneNumbers,
                channel,
                selectedTemplate,
                templateParams,
                ticimaxPayload,
                sendTemplateViaMmlite,
            }),
        cancel: (id) => request.post(`/whatsapp/broadcast/messages/${id}/cancel`, {}).then((res) => res.data),
    },
    BUSINESS: {
        getTemplates: (channelId) => request.get(`/whatsapp/business/${channelId}/templates`),
        deleteTemplate: (channelId, templateName) =>
            request.delete(`/whatsapp/business/${channelId}/${templateName}/force`),
        updateVoiceConfiguration: (channelId, enable, metaData) =>
            request.post(`/whatsapp/business/${channelId}/voice`, { enable, metaData }),
    },
    INSIGHTS: {
        getMessagingAnalytics: (channelId, params) =>
            request.get(`/whatsapp/insights/${channelId}/messaging`, { params }).then((res) => res.data),
        getConversationAnalytics: (channelId, params) =>
            request.get(`/whatsapp/insights/${channelId}/conversation`, { params }).then((res) => res.data),
        getPricingAnalytics: (channelId, params) =>
            request.get(`/whatsapp/insights/${channelId}/pricing`, { params }).then((res) => res.data),
        getTemplateAnalytics: (channelId, params) =>
            request.get(`/whatsapp/insights/${channelId}/template`, { params }).then((res) => res.data),
        getTemplateGroupAnalytics: (channelId, params) =>
            request.get(`/whatsapp/insights/${channelId}/template-group`, { params }).then((res) => res.data),
    },
    getWabaAccountActivityLog: (channelId, params) =>
        request.get(`/whatsapp/internal/waba/account-activity-log/${channelId}`, { params }).then((res) => res.data),
};
export default WHATSAPP_API;
